import { IJobName, IJobNameAction } from "./jobnameReducer";


export function jobnameUpdate(jobNames: IJobName): IJobNameAction {
    return {
        type: "JOBNAME_UPDATE",
        payload: jobNames,
    }
}

export function jobnameAdd(jobNames: IJobName): IJobNameAction {
    return {
        type: "JOBNAME_ADD",
        payload: jobNames,
    }
}

export function jobnameClear(): IJobNameAction {
    return {
        type: "JOBNAME_CLEAR",
    }
}